(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var MAX_SHIFT = 8;

    function shift(card, event) {
      var frame = card.querySelector('[data-card-frame]');
      if (!frame) return;
      var box = frame.getBoundingClientRect();
      var relativeX = (event.clientX - box.left) / box.width - 0.5;
      var relativeY = (event.clientY - box.top) / box.height - 0.5;
      card.style.setProperty('--card-shift-x', (-relativeX * MAX_SHIFT * 2).toFixed(2) + 'px');
      card.style.setProperty('--card-shift-y', (-relativeY * MAX_SHIFT * 2).toFixed(2) + 'px');
    }

    function reset(card) {
      card.style.setProperty('--card-shift-x', '0px');
      card.style.setProperty('--card-shift-y', '0px');
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;

    document.addEventListener(
      'pointermove',
      function (event) {
        var card = event.target instanceof Element ? event.target.closest('[data-product-card]') : null;
        if (card) shift(card, event);
      },
      { passive: true }
    );

    document.addEventListener(
      'pointerout',
      function (event) {
        var card = event.target instanceof Element ? event.target.closest('[data-product-card]') : null;
        if (card && !card.contains(event.relatedTarget)) reset(card);
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
